import {Button} from 'antd'
import {useFilterByLicense} from '@/biz/license.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonGenCode(props) {
    const filterByLicense = useFilterByLicense()
    const map = useMapContext()
    const onClick = () => map.commands.aiGenerateCode(map.selectedNodes)

    return filterByLicense('M00040003',
        <Button
            onClick={onClick}
            {...props}
        >
            生成代码
        </Button>
    )
}
